module.exports = __webpack_public_path__ + "static/media/canteen-icon.f4a36ace.png";